/**
 * AssetCardGrid — Groups asset cards by domain in a responsive grid.
 */

import type { AssetSummary, Domain, FuelState, AssetLoadout } from '../../../types'
import { DOMAIN_CONFIG } from '../../../types'
import { AssetCard } from './AssetCard'

interface AssetCardGridProps {
  assets: AssetSummary[]
  fuelMap: Record<string, FuelState>
  loadoutMap: Record<string, AssetLoadout>
  onSelectAsset: (assetId: string) => void
}

const DOMAIN_ORDER: Domain[] = ['AIR', 'SEA', 'SPACE', 'CYBER', 'GROUND']

export function AssetCardGrid({ assets, fuelMap, loadoutMap, onSelectAsset }: AssetCardGridProps) {
  return (
    <div className="flex flex-col gap-4 overflow-auto flex-1 min-h-0">
      {DOMAIN_ORDER.map(domain => {
        const domainAssets = assets.filter(a => a.domain === domain)
        if (domainAssets.length === 0) return null
        const color = DOMAIN_CONFIG[domain].color

        return (
          <div key={domain}>
            {/* Domain header */}
            <div className="flex items-center gap-2 mb-2">
              <span className="text-xs font-bold uppercase tracking-wider" style={{ color }}>
                {DOMAIN_CONFIG[domain].label}
              </span>
              <span className="text-[10px] text-term-textDim">({domainAssets.length})</span>
              <div className="flex-1 h-px" style={{ backgroundColor: `${color}30` }} />
            </div>

            {/* Card grid */}
            <div
              className="grid gap-3"
              style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))' }}
            >
              {domainAssets.map(a => (
                <AssetCard
                  key={a.id}
                  asset={a}
                  fuel={fuelMap[a.id]}
                  loadout={loadoutMap[a.id]}
                  onSelect={onSelectAsset}
                />
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
